import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MailCheck, MailX, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

export default function VerifyEmail() {
  const { t, user, refreshUser } = useApp();
  const token = new URLSearchParams(useLocation().search).get("token");
  const [state, setState] = useState(token ? "checking" : "error");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) return;
    api.post("/auth/verify-email", { token })
      .then(async () => { setState("ok"); if (user) await refreshUser(); })
      .catch((e) => { setMsg(formatApiErrorDetail(e.response?.data?.detail)); setState("error"); });
    // eslint-disable-next-line
  }, [token]);

  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-5 py-24 text-center" data-testid="verify-email-page">
      {state === "checking" && <><Loader2 className="animate-spin text-[#002FA7]" size={40} /><p className="mt-4 text-gray-500">{t("verify_checking")}</p></>}
      {state === "ok" && <><MailCheck className="text-[#155724]" size={48} /><h1 className="mt-4 font-display text-2xl font-extrabold" data-testid="verify-success">{t("verify_success_title")}</h1><p className="mt-2 text-gray-500">{t("verify_success_body")}</p><Link to={user ? "/create" : "/login"} data-testid="verify-continue" className="mt-6 rounded-full bg-[#002FA7] px-6 py-3 font-bold text-white">{user ? t("verify_cta_publish") : t("nav_login")}</Link></>}
      {state === "error" && <><MailX className="text-[#FF3B30]" size={48} /><h1 className="mt-4 font-display text-2xl font-extrabold" data-testid="verify-error">{t("verify_error_title")}</h1><p className="mt-2 text-gray-500">{msg || t("verify_error_body")}</p><Link to="/profile" data-testid="verify-go-profile" className="mt-6 rounded-full border border-[#002FA7] px-6 py-3 font-bold text-[#002FA7]">{t("verify_resend_from_profile")}</Link></>}
    </div>
  );
}
